import React, { cloneElement, Children } from 'react';
import { useController } from 'react-hook-form';
import VoiceMicButton from '../../components/VoiceMicButton';

const VoiceInputWrapper = ({ child, field, name }) => {
  const clonedChild = cloneElement(child, {
    id: name,
    "data-testid": name,
    ...field,
    value: field.value || '',
    style: {
      ...(child.props?.style || {}),
      paddingRight: '36px'
    }
  });

  // Only add voice button to text inputs and textareas
  const isTextInput = child.type === 'input' && 
      (!child.props.type || ['text', 'search', 'url', 'tel', 'email'].includes(child.props.type));
  const isTextArea = child.type === 'textarea';

  if (!isTextInput && !isTextArea) {
    return cloneElement(child, {
      id: name,
      "data-testid": name,
      ...field,
      value: field.value || '',
    });
  }

  return (
    <div style={{ position: 'relative', display: 'flex', alignItems: 'center', width: '100%' }}>
      <div style={{ flexGrow: 1, width: '100%' }}>
        {clonedChild}
      </div>
      <div
        style={{
          position: 'absolute',
          right: '8px',
          top: isTextArea ? '10px' : '50%',
          transform: isTextArea ? 'none' : 'translateY(-50%)',
          zIndex: 5
        }}
      >
        <VoiceMicButton
          initialText={field.value || ''}
          onTranscript={(text) => field.onChange(text)}
          size={16}
        />
      </div>
    </div>
  );
};

export default function RFG(props) {
  const { children, label, name } = props;
  const { field, fieldState } = useController(props);

  return (
    <>
      <label className="input-label" style={props?.labelStyle}>{label}</label>
      <div className="mb-3">
        {Children.map(children, child => (
          <VoiceInputWrapper child={child} field={field} name={name} />
        ))}
        <div className="error mb-2 text-red-500 text-sm">
          {fieldState?.error?.type === 'required' && `${name} is required`}
          {fieldState?.error?.message}
        </div>
      </div>
    </>
  );
}
